// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1rL6_","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1Iyus"};